import React from 'react';
import { FaShieldAlt, FaLock, FaQrcode, FaClipboardList, FaFileAlt } from 'react-icons/fa';

const SecuritySection = () => {
  return (
    <>
      {/* Security Section start */}
      <div id="seguridad" className="service-area bg-gray pd-top-100 pd-bottom-100">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">MÁXIMA SEGURIDAD</h6>
            <h2 className="title">
              Seguridad y <span>validación</span>
            </h2>
            <p className="content mb-5">
              Tu información y documentos están protegidos con los más altos estándares de seguridad
            </p>
          </div>
          {/* Primera fila - 3 elementos */}
          <div className="row justify-content-center mb-4">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaShieldAlt size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">OTP por correo</h5>
                  <p>
                    Código de verificación con vigencia de 5 minutos. 
                    Posibilidad de reenvío en caso de expiración.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaClipboardList size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">Huella de auditoría</h5>
                  <p>
                    Registro completo: IP, fecha y hora por cada firmante.
                    Trazabilidad total del proceso.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaQrcode size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">QR de verificación</h5>
                  <p>
                    Código QR en el PDF para validar autenticidad en línea.
                    Verificación inmediata de integridad.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Segunda fila - 2 elementos centrados */}
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaFileAlt size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">RUT del firmante</h5>
                  <p>
                    Identificación del firmante bajo su nombre en el documento
                    para mayor trazabilidad.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaLock size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">Cifrado completo</h5>
                  <p>
                    Cifrado en tránsito y en reposo. Controles de acceso 
                    por rol en la plataforma.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Security Section end */}
    </>
  );
};

export default SecuritySection;
